import { useCallback, useMemo } from 'react';
import { createMMKV } from 'react-native-mmkv';

// ─────────────────────────────────────────────────────────────────────────────

export const useNavbarNewContentIndicator = (links: string[]) => {
  const unseenLinks = useMemo(() => {
    const lastSeenLinks = getLastSeenLinks();

    // Handles first time users, no links are considered new.
    if (lastSeenLinks.length === 0) return new Set([]);

    return new Set(links.filter((link) => !lastSeenLinks.includes(link)));
  }, [links]);

  const storeLastSeenLinks = useCallback(() => {
    setLastSeenLinks(links);
  }, [links]);

  return {
    hasNewContent: unseenLinks.size > 0,
    unseenLinks,
    storeLastSeenLinks,
  };
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function setLastSeenLinks(links: string[]) {
  STORAGE.set(LAST_SEEN_LINKS_KEY, links.join(','));
}

function getLastSeenLinks() {
  const lastSeenLinks = STORAGE.getString(LAST_SEEN_LINKS_KEY);

  if (!lastSeenLinks) return [];

  return lastSeenLinks.split(',');
}

// ─── Constants ───────────────────────────────────────────────────────────────

const STORAGE = createMMKV({ id: 'sg.navbar' });
const LAST_SEEN_LINKS_KEY = 'navbar-last-seen-links';
